import { Modal, toast } from '@insight-health-ai/roseate/components';
import { Form, Input, Select } from 'antd';
import { AxiosError } from 'axios';
import { useCreateServiceRequestType } from 'src/hooks/serviceRequest';
import { useGetServiceRequestStatuses } from 'src/hooks/serviceRequest/useGetServiceRequestStatuses';
import { ServiceRequestType } from 'src/models/serviceRequest';

export const CreateServiceRequestType = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: (serviceRequestType?: ServiceRequestType) => void;
}) => {
  const [form] = Form.useForm();

  const {
    data: serviceRequestStatuses,
    isLoading: isLoadingServiceRequestStatuses,
  } = useGetServiceRequestStatuses();

  const { mutateAsync: createServiceRequestType } =
    useCreateServiceRequestType();

  const handleSubmit = async () => {
    const { name, key, initial_status, mode } = await form.validateFields();

    try {
      const data = await createServiceRequestType({
        service_request_type: name,
        service_request_key: key,
        initial_status: initial_status.label,
        mode: mode || 'chat',
      });
      onClose(data);
    } catch (error) {
      toast.error(
        (error as AxiosError<{ message: string }>).response?.data.message ||
          'Failed to create service request type'
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        form.resetFields();
        onClose();
      }}
      title="Create Service Request Type"
      primaryAction={{
        label: 'Create',
        onClick: handleSubmit,
      }}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          className="field-wrapper"
          label={<span className="label">Type Name</span>}
          rules={[{ required: true, message: 'Type name is required' }]}
          name="name"
        >
          <Input className="field" placeholder="Enter type name" />
        </Form.Item>
        <Form.Item
          className="field-wrapper"
          label={<span className="label">Type Key</span>}
          rules={[{ required: true, message: 'Type key is required' }]}
          name="key"
        >
          <Select
            className="field"
            placeholder="Select type key"
            options={[
              { label: 'Referral', value: 'referral' },
              { label: 'Recall', value: 'recall' },
              { label: 'Fax Referral', value: 'fax-referral' },
            ]}
          />
        </Form.Item>
        <Form.Item
          className="field-wrapper"
          label={<span className="label">Initial Status</span>}
          name="initial_status"
          rules={[{ required: true, message: 'Initial status is required' }]}
          extra="Recommend setting initial status to 'scheduled' for normal and 'processing' for fax referral types"
        >
          <Select
            className="field"
            placeholder="Select initial status"
            loading={isLoadingServiceRequestStatuses}
            disabled={isLoadingServiceRequestStatuses}
            showSearch
            filterOption={(input, option) =>
              (option?.label || '')
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            labelInValue
            options={serviceRequestStatuses?.map((status) => ({
              label: status.status_name,
              value: status.status_id,
            }))}
          />
        </Form.Item>
        <Form.Item
          className="field-wrapper"
          label={<span className="label">Mode</span>}
          name="mode"
          initialValue="chat"
        >
          <Select
            className="field"
            options={[
              { label: 'Chat', value: 'chat' },
              { label: 'Form', value: 'form' },
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
